import { IMG, FLAGS } from "./shared";

const de = {
  langName: "DE",
  nav: {
    brand: "Barlow Consultants",
    brandSub: "SL · LUXEMBOURG",
    links: [
      { label: "Festgeld", href: "#konditionen" },
      { label: "Sicherheit", href: "#sicherheit" },
      { label: "Vermögensverwaltung", href: "#vermoegen" },
      { label: "Beratung", href: "#beratung" },
      { label: "Team", href: "#team" },
      { label: "Zinsrechner", href: "#rechner" },
    ],
  },
  ui: {
    login: "Anmelden",
    openAccount: "Konto eröffnen",
    portal: "Kundenportal",
    invest: "Anlegen",
    ratePa: "Zinssatz p.a.",
  },
  hero: {
    eyebrow: "Privates & Unternehmens-Festgeld · Luxemburg",
    titlePre: "Sicheres Festgeld mit",
    titleAccent: "planbarer",
    titlePost: "Rendite.",
    text: "Eröffnen Sie Ihr Festgeldkonto bei Barlow Consultants SL – für Privatpersonen und Unternehmen (Unternehmensfestgeld). Lassen Sie Ihr Kapital zu attraktiven Festzinsen für Sie arbeiten – transparent, sicher und vollständig digital.",
    network: "Zugang zu über 50 europäischen Banken – plus führende Banken im Vereinigten Königreich.",
    badge1: "inkl. persönlicher Vermögensberatung",
    badge2: "Doppelt abgesichert · Einlagensicherung + Treuhandkonto",
    btnOpen: "Jetzt Konto eröffnen",
    btnConditions: "Konditionen ansehen",
    btnAdvice: "Beratung entdecken",
    floatGuarantee: "Ihre Einlagen sind gesetzlich bis zu 100.000 € pro Kunde und Bank geschützt.",
    floatRateLabel: "Feste Zinsen p.a.",
    image: IMG.hero,
    stats: [
      { icon: "Landmark", label: "Verwahrt bei regulierter Partnerbank" },
      { icon: "TrendingUp", label: "Feste Zinsen bis 4,25 %" },
      { icon: "CalendarClock", label: "Laufzeiten von 6 bis 60 Monaten" },
    ],
  },
  network: {
    eyebrow: "Unser Bankennetzwerk",
    title: "Ein starkes Netzwerk europäischer Banken",
    text: "Wir arbeiten mit mehr als 50 Banken in Europa zusammen und bieten zusätzlich Zugang zu ausgewählten führenden Banken im Vereinigten Königreich.",
    overlay1: "europäische Banken",
    overlay2: "+ führende UK-Banken",
    btnDiscover: "Festgeldangebote entdecken",
    btnCompare: "Angebote vergleichen",
    image: IMG.network,
    cards: [
      { icon: "Globe", title: "50+ europäische Banken", text: "Zugang zu einem umfangreichen Netzwerk von Banken aus verschiedenen europäischen Ländern." },
      { icon: "Building2", title: "Zusätzlich UK-Banken", text: "Ergänzend arbeiten wir mit ausgewählten führenden Banken aus dem Vereinigten Königreich." },
      { icon: "Layers", title: "Viele Angebote – eine Übersicht", text: "Unsere Plattform ermöglicht es Interessenten, verschiedene Festgeldangebote übersichtlich zu vergleichen." },
    ],
    flagsLabel: "Vertreten in ganz Europa und im Vereinigten Königreich",
    flags: FLAGS,
  },
  conditions: {
    title: "Festgeld-Konditionen",
    text: "Feste Zinssätze für die gesamte Laufzeit. Kein Kursrisiko, volle Planbarkeit.",
    invest: "Anlegen",
    ratePa: "Zinssatz p.a.",
    rows: [
      { term: "6 Monate", months: 6, rate: 2.8 },
      { term: "12 Monate", months: 12, rate: 3.3 },
      { term: "24 Monate", months: 24, rate: 3.6 },
      { term: "36 Monate", months: 36, rate: 3.9 },
      { term: "60 Monate", months: 60, rate: 4.25 },
    ],
  },
  security: {
    eyebrow: "Doppelte Sicherheit",
    title: "Ihr Kapital – zweifach abgesichert",
    text: "Ihre Einlagen sind gleich doppelt geschützt: durch die gesetzliche europäische Einlagensicherung und zusätzlich durch die Verwahrung auf einem Treuhandkonto.",
    layers: [
      {
        level: "Ebene 1", badge: "bis 100.000 €", badgeSub: "pro Einleger geschützt",
        title: "Gesetzliche Einlagensicherung",
        text: "Die bei einer regulierten Partnerbank in Luxemburg verwahrten Gelder unterliegen dem gesetzlichen Einlagensicherungssystem Luxemburgs (FGDL – Fonds de garantie des dépôts Luxembourg). Im Einklang mit der EU-Richtlinie 2014/49/EU sind Einlagen je Einleger und Institut bis zu 100.000 € abgesichert.",
        note: "Verwahrung bei regulierter Partnerbank in Luxemburg · Abgesichert gemäß EU-Richtlinie 2014/49/EU",
        link: "Mehr zur Einlagensicherung",
      },
      {
        level: "Ebene 2", badge: "Treuhandkonto", badgeSub: "zusätzlicher Schutz",
        title: "Zusätzlicher Treuhandschutz",
        text: "Zusätzlich zur gesetzlichen Einlagensicherung werden Ihre Einlagen treuhänderisch auf einem Treuhandkonto nach klaren Verwahrregeln verwaltet.",
        bullets: [
          "Treuhänderische Verwaltung nach klaren Verwahrregeln",
          "Zusätzliche Sicherungsebene über die Einlagensicherung hinaus",
        ],
      },
    ],
  },
  whyUs: {
    title: "Warum Barlow Consultants",
    items: [
      { icon: "ShieldCheck", title: "Kapitalsicherheit", text: "Ihre Einlagen werden bei einer regulierten Partnerbank in Luxemburg verwahrt." },
      { icon: "Percent", title: "Feste Rendite", text: "Der Zinssatz steht bei Vertragsabschluss fest – für die komplette Laufzeit." },
      { icon: "Eye", title: "Volle Transparenz", text: "Jederzeit Einblick in Kontostand, Anlagen und Zinsprognosen in Ihrem Depot." },
      { icon: "MonitorSmartphone", title: "Digitale Eröffnung", text: "Konto in wenigen Minuten online eröffnen – ganz ohne Papierkram." },
    ],
  },
  wealth: {
    eyebrow: "Private Vermögensverwaltung · Luxemburg",
    title: "Mehr als Festgeld – Ihre private Vermögensverwaltung.",
    text: "Barlow Consultants SL ist nicht nur Ihr Partner für Festgeld, sondern auch für die professionelle Verwaltung Ihres Vermögens. Wir entwickeln eine auf Sie zugeschnittene Strategie und begleiten Sie langfristig mit Diskretion und Weitblick.",
    image: IMG.wealth,
    cta: "Beratung anfragen",
    items: [
      { icon: "Target", title: "Individuelle Anlagestrategie", text: "Ein Portfolio, das auf Ihre Ziele, Ihren Zeithorizont und Ihre Risikobereitschaft abgestimmt ist." },
      { icon: "Activity", title: "Aktives Portfolio-Management", text: "Breit gestreute Anlagen über Anlageklassen hinweg – laufend überwacht und angepasst." },
      { icon: "UserRound", title: "Persönliche Betreuung", text: "Ein fester Ansprechpartner, der Ihre Vermögenssituation kennt und für Sie erreichbar ist." },
      { icon: "Shield", title: "Vermögensschutz", text: "Kapitalerhalt und Absicherung stehen im Mittelpunkt – für Sie und die nächste Generation." },
    ],
  },
  advisory: {
    eyebrow: "Persönliche Vermögensberatung",
    title: "Ein persönlicher Berater an Ihrer Seite",
    text: "Mehr als Festgeld: Unsere erfahrenen Berater entwickeln gemeinsam mit Ihnen eine Anlagestrategie, die zu Ihren Zielen, Ihrer Lebenssituation und Ihrem Sicherheitsbedürfnis passt – transparent, unabhängig und ohne Verkaufsdruck.",
    image: IMG.advisory,
    suitableTitle: "Für wen geeignet",
    cta: "Beratungsgespräch vereinbaren",
    suitable: [
      "Sparer, die ihr Vermögen langfristig und sicher anlegen möchten",
      "Menschen vor oder im Ruhestand mit Wunsch nach planbaren Erträgen",
      "Anleger, die persönliche Betreuung statt anonymer Apps schätzen",
    ],
    items: [
      { icon: "Target", title: "Individuelle Strategie", text: "Ihre Anlage wird auf Ihre Ziele, Laufzeiten und Risikobereitschaft zugeschnitten." },
      { icon: "UserRound", title: "Fester Ansprechpartner", text: "Ein persönlicher Berater begleitet Sie – erreichbar, verständlich und verbindlich." },
      { icon: "Receipt", title: "Transparente Kosten", text: "Klare Konditionen ohne versteckte Gebühren. Sie wissen jederzeit, woran Sie sind." },
      { icon: "RefreshCw", title: "Laufende Betreuung", text: "Wir überprüfen Ihre Strategie regelmäßig und passen sie bei Bedarf an." },
    ],
  },
  process: {
    eyebrow: "So läuft Ihre Beratung ab",
    title: "In vier Schritten zu Ihrer Strategie",
    text: "Unkompliziert, unverbindlich und in Ihrem Tempo.",
    steps: [
      { no: "01", title: "Erstgespräch", text: "Wir lernen Sie und Ihre Ziele kennen – kostenlos und unverbindlich." },
      { no: "02", title: "Analyse", text: "Wir analysieren Ihre Situation und Ihren Anlagehorizont im Detail." },
      { no: "03", title: "Strategie", text: "Sie erhalten einen klaren, verständlichen Anlagevorschlag." },
      { no: "04", title: "Betreuung", text: "Wir setzen die Strategie um und begleiten Sie dauerhaft." },
    ],
    stats: [
      { value: "500+", label: "Betreute Kundinnen und Kunden" },
      { value: "15 Jahre", label: "Erfahrung in der Vermögensberatung" },
      { value: "100 %", label: "Persönlicher Ansprechpartner" },
      { value: "0 €", label: "Kosten für das Erstgespräch" },
    ],
  },
  corporate: {
    eyebrow: "Unternehmensberatung",
    title: "Ihre persönlichen Unternehmensberater",
    text: "Feste Ansprechpartner für Unternehmens-Festgeld – kompetent, diskret und immer für Sie erreichbar.",
    ctaTitle: "Bereit für ein persönliches Gespräch?",
    ctaText: "Vereinbaren Sie Ihr kostenloses und unverbindliches Beratungsgespräch.",
    ctaBtn: "Beratungsgespräch vereinbaren",
    people: [
      { initials: "LP", name: "Leon Peterson", role: "Unternehmensberater", region: "DACH-Region Deutschland", phone: "+49 30 8268 8142" },
      { initials: "TB", name: "Tanja Berg", role: "Unternehmensberaterin", region: "DACH-Region Deutschland", phone: "+49 30 8268 5344" },
      { initials: "DW", name: "Dr. Denis Weilandt", role: "Unternehmensberater", region: "DACH-Region Deutschland", phone: "+49 30 8268 6108" },
    ],
  },
  strategies: {
    eyebrow: "Anlagestrategien",
    title: "Drei Strategien für Ihr Vermögen.",
    text: "Von kapitalschonend bis wachstumsorientiert – wir finden die passende Strategie für Ihre Ziele. Die angegebenen Renditen sind Zielwerte und keine Garantie.",
    expectedReturn: "Erwartete Rendite p.a.",
    risk: "Risiko",
    allocation: "Portfolio-Aufteilung",
    popular: "Beliebt",
    cta: "Strategie besprechen",
    items: [
      { name: "Konservativ", ret: "2 – 4 %", risk: "Niedrig", popular: false, text: "Kapitalerhalt im Fokus: Festgeld, Anleihen hoher Bonität und Liquidität. Geringe Schwankungen.", alloc: [{ k: "Festgeld", v: 70 }, { k: "Anleihen", v: 25 }, { k: "Aktien", v: 5 }] },
      { name: "Ausgewogen", ret: "4 – 6 %", risk: "Mittel", popular: true, text: "Ausgewogene Mischung aus Anleihen und Aktien für stetiges Wachstum bei moderatem Risiko.", alloc: [{ k: "Festgeld", v: 30 }, { k: "Anleihen", v: 35 }, { k: "Aktien", v: 35 }] },
      { name: "Wachstum", ret: "6 – 9 %", risk: "Hoch", popular: false, text: "Aktienbetonte Ausrichtung für langfristigen Vermögensaufbau – höhere Schwankungen möglich.", alloc: [{ k: "Festgeld", v: 10 }, { k: "Anleihen", v: 25 }, { k: "Aktien", v: 65 }] },
    ],
  },
  steps: {
    title: "In drei Schritten zum Festgeld",
    stepWord: "Schritt",
    items: [
      { no: "01", title: "Konto eröffnen", text: "Registrieren Sie sich kostenlos und erhalten Sie Ihr persönliches Konto mit persönlicher Referenznummer." },
      { no: "02", title: "Kapital einzahlen", text: "Überweisen Sie Ihren Anlagebetrag auf das angegebene Verwahrkonto." },
      { no: "03", title: "Festgeld anlegen", text: "Wählen Sie Laufzeit und Betrag – Ihre Rendite läuft automatisch." },
    ],
  },
  fees: {
    eyebrow: "Transparenz",
    title: "Gebührenübersicht",
    note: "Keine versteckten Kosten – volle Transparenz.",
    rows: [
      { k: "Kontoeröffnung", v: "0 €" },
      { k: "Einzahlung", v: "0 €" },
      { k: "Verwaltung / Kontoführung", v: "0 €" },
      { k: "Performance Fee", v: "keine (nur bei Vermögensverwaltung)" },
      { k: "Auszahlung bei Fälligkeit", v: "0 €" },
      { k: "Sonstige Gebühren", v: "keine versteckten Gebühren" },
    ],
  },
  calculator: {
    title: "Zinsrechner",
    subtitle: "Berechnen Sie Ihre Rendite und sehen Sie, wie Ihr Kapital bei automatischer Wiederanlage über die Jahre wächst.",
    amount: "Anlagebetrag",
    term: "Laufzeit",
    horizon: "Zeithorizont",
    years: "Jahre",
    ratePa: "Zinssatz p.a.",
    interestTerm: "Zinsen (Laufzeit)",
    payout: "Auszahlung",
    capitalAfter: "Kapital nach",
    developmentReinvest: "Entwicklung bei automatischer Wiederanlage",
    totalInterest: "Gesamtzinsen",
    openAccount: "Konto eröffnen",
  },
  team: {
    eyebrow: "Unser Team",
    title: "Das verantwortliche Team",
    text: "Klare Verantwortlichkeiten und feste Ansprechpartner – für Ihr Vertrauen.",
    members: [
      { name: "Francesco Vigna", role: "Geschäftsführung", img: IMG.team[0], text: "Francesco Vigna verantwortet die strategische Ausrichtung von Barlow Consultants SL und bringt langjährige Erfahrung in Festgeld- und Vermögensverwaltungsprodukten mit." },
      { name: "Isabel Moreno", role: "Leitung Kundenbetreuung", img: IMG.team[1], text: "Isabel Moreno ist erste Ansprechpartnerin für unsere Kundinnen und Kunden und sorgt für einen persönlichen, transparenten Service in allen Phasen der Anlage." },
      { name: "Henrik Larsson", role: "Leitung Anlagestrategie", img: IMG.team[2], text: "Henrik Larsson entwickelt und überwacht unsere Anlagestrategien und achtet auf ein ausgewogenes Verhältnis von Chancen und Risiken." },
    ],
  },
  testimonials: {
    eyebrow: "Kundenstimmen",
    title: "Verifizierte Kundenstimmen",
    text: "Echte Erfahrungen unserer Kundinnen und Kunden – nachvollziehbar gekennzeichnet.",
    customerSince: "Kunde seit",
    items: [
      { quote: "Der gesamte Ablauf war transparent und unkompliziert – von der Kontoeröffnung bis zur pünktlichen Zinsgutschrift bei Fälligkeit. Genau so wünscht man sich Festgeld.", name: "Markus Hoffmann", country: "Deutschland", since: "2025 · verifiziert" },
      { quote: "Was mich überzeugt hat: Gebühren und Risiken werden klar benannt, ganz ohne Kleingedrucktes. Der persönliche Kontakt war immer kompetent und freundlich.", name: "Sophie Berger", country: "Luxemburg", since: "2025 · verifiziert" },
      { quote: "Ich habe mehrere Anbieter verglichen. Die klare Kostenstruktur und die verständliche Übersicht im Kundenkonto haben den Ausschlag gegeben.", name: "Daniel Rößler", country: "Österreich", since: "2024 · verifiziert" },
      { quote: "Seriös, verständlich und verlässlich. Meine Fragen wurden stets rasch beantwortet und die Konditionen genau wie besprochen umgesetzt.", name: "Elena Fischer", country: "Schweiz", since: "2025 · verifiziert" },
    ],
  },
  contact: {
    eyebrow: "Beratungstermin",
    title: "Kostenloses Beratungsgespräch vereinbaren",
    text: "Hinterlassen Sie uns Ihre Daten – ein persönlicher Berater meldet sich zeitnah bei Ihnen. Unverbindlich und kostenfrei.",
    perks: ["Individuelle Strategie", "Fester Ansprechpartner", "Transparente Kosten", "Laufende Betreuung"],
    form: {
      name: "Vollständiger Name",
      email: "E-Mail-Adresse",
      phone: "Telefon (optional)",
      amount: "Geplanter Anlagebetrag (optional)",
      message: "Ihre Nachricht (optional)",
      submit: "Beratung anfragen",
    },
    toastErr: "Bitte Name und E-Mail-Adresse angeben.",
    toastOk: "Vielen Dank! Ein Berater meldet sich zeitnah bei Ihnen.",
  },
  finalCta: {
    title: "Bereit, Ihr Kapital arbeiten zu lassen?",
    text: "Eröffnen Sie noch heute Ihr Festgeldkonto bei Barlow Consultants SL.",
    button: "Jetzt Konto eröffnen",
  },
  cookie: {
    text: "Wir verwenden notwendige Cookies für den Betrieb der Seite sowie optionale Cookies, um Ihr Erlebnis zu verbessern. Sie entscheiden, was Sie zulassen.",
    necessary: "Nur notwendige",
    all: "Alle akzeptieren",
    more: "Mehr erfahren",
  },
  footer: {
    tagline: "Festgeld & Vermögensberatung mit europäischer Einlagensicherung und Treuhandkonto.",
    navTitle: "Navigation",
    legalTitle: "Rechtliches",
    legalLinks: ["Impressum", "Datenschutz", "AGB", "Einlagensicherung", "Cookies"],
    contactTitle: "Kontakt",
    contactLines: ["Barlow Consultants SL", "Luxembourg"],
    deOfficeTitle: "Niederlassung Deutschland",
    deOfficeLines: ["Barlow Consultants", "Kurfürstendamm 30", "10719 Berlin", "Deutschland"],
    rights: "Alle Rechte vorbehalten.",
    disclaimer: "Einlagen bis 100.000 € abgesichert gemäß EU-Richtlinie 2014/49/EU.",
  },
  accountModal: {
    title: "Festgeldkonto eröffnen",
    desc: "Kostenlos und in wenigen Minuten – ganz ohne Papierkram.",
    name: "Vollständiger Name",
    email: "E-Mail-Adresse",
    amount: "Betrag (€)",
    submit: "Konto eröffnen",
    note: "bis zu 100.000 € abgesichert durch die FGDL",
    toastErr: "Bitte Name und E-Mail-Adresse angeben.",
    toastOk: "Konto-Anfrage erhalten!",
    errGeneric: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    successTitle: "Konto-Anfrage erhalten!",
    successText: "Vielen Dank. Ihre Anfrage wurde erfasst.",
    refLabel: "Ihre persönliche Referenznummer",
    successNote: "Bitte notieren Sie diese Referenznummer. Ein Berater setzt sich in Kürze mit Ihnen in Verbindung.",
    done: "Fertig",
    copied: "Referenznummer kopiert",
  },
  portal: {
    backHome: "Zurück zur Website",
    logout: "Abmelden",
    loginTitle: "Willkommen im Kundenportal",
    loginSubtitle: "Melden Sie sich an, um Kontostand, Anlagen und Zinsprognosen einzusehen.",
    loginHeadline: "Willkommen zurück",
    loginSub: "Melden Sie sich in Ihrem Depot an.",
    authImageTitle: "Sicheres Festgeld mit planbarer Rendite.",
    authImageSub: "Verwahrt bei Banking Circle S.A. · Feste Zinsen bis 4,25 %",
    emailLabel: "E-Mail-Adresse",
    passwordLabel: "Passwort",
    loginBtn: "Anmelden",
    demoTitle: "Demo-Zugang",
    demoHint: "Zum Ausprobieren nutzen Sie bitte:",
    useDemo: "Demo-Daten einsetzen",
    loginErr: "Ungültige Zugangsdaten. Bitte verwenden Sie den Demo-Zugang.",
    loginOk: "Erfolgreich angemeldet.",
    welcome: "Willkommen,",
    refNo: "Referenznummer",
    totalBalance: "Gesamtkapital",
    investedCapital: "Angelegtes Kapital",
    projectedInterest: "Erwartete Zinsen bis Fälligkeit",
    avgRate: "Ø Zinssatz",
    activeDeposits: "Laufende Festgeld-Anlagen",
    colAmount: "Anlagebetrag",
    colTerm: "Laufzeit",
    colRate: "Zinssatz",
    colMaturity: "Fälligkeit",
    colInterest: "Zinsertrag",
    colStatus: "Status",
    statusActive: "Aktiv",
    months: "Monate",
    forecastTitle: "Zinsprognose",
    forecastNote: "Prognostizierte Kapitalentwicklung bei automatischer Wiederanlage",
    years: "Jahre",
    afterYears: "Kapital nach",
    newDeposit: "Neue Anlage eröffnen",
    registerTitle: "Konto eröffnen",
    registerSubtitle: "Erstellen Sie Ihr persönliches Festgeldkonto.",
    depositNote: "bis 100.000 € abgesichert",
    accountTypeLabel: "Kontotyp",
    accTypePrivate: "Privatperson",
    accTypeCompany: "Unternehmen",
    nameLabel: "Vollständiger Name",
    countryLabel: "Land",
    countryPlaceholder: "Land auswählen",
    phoneLabel: "Telefon",
    consentIntro: "Ich akzeptiere die",
    consentTerms: "Nutzungsbedingungen",
    consentAgb: "AGB",
    consentMid: "und die",
    consentPrivacy: "Datenschutzerklärung",
    errConsent: "Bitte akzeptieren Sie die AGB und die Datenschutzerklärung.",
    registerBtn: "Konto eröffnen",
    noAccount: "Noch kein Konto?",
    toRegister: "Jetzt registrieren",
    haveAccount: "Bereits registriert?",
    toLogin: "Anmelden",
    registerOk: "Konto erfolgreich erstellt.",
    errEmailExists: "Diese E-Mail-Adresse ist bereits registriert.",
    errPassword: "Das Passwort muss mindestens 6 Zeichen lang sein.",
    errEmailInvalid: "Bitte geben Sie eine gültige E-Mail-Adresse an.",
    errGeneric: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    changePwTitle: "Passwort ändern",
    changePwSubtitle: "Aktualisieren Sie Ihr Passwort regelmäßig, um Ihr Konto zu schützen.",
    currentPwLabel: "Aktuelles Passwort",
    newPwLabel: "Neues Passwort",
    confirmPwLabel: "Neues Passwort bestätigen",
    changePwBtn: "Passwort ändern",
    changePwOk: "Passwort erfolgreich geändert.",
    errWrongPw: "Das aktuelle Passwort ist falsch.",
    errPwMismatch: "Die neuen Passwörter stimmen nicht überein.",
    errSamePw: "Das neue Passwort muss sich vom aktuellen unterscheiden.",
    forgotPw: "Passwort vergessen?",
    forgotTitle: "Passwort zurücksetzen",
    forgotSubtitle: "Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Link zum Zurücksetzen.",
    forgotBtn: "Link senden",
    forgotOk: "Falls ein Konto existiert, haben wir Ihnen einen Link zum Zurücksetzen gesendet.",
    backToLogin: "Zurück zur Anmeldung",
    resetTitle: "Neues Passwort festlegen",
    resetSubtitle: "Wählen Sie ein neues Passwort für Ihr Konto.",
    resetBtn: "Passwort speichern",
    resetOk: "Passwort erfolgreich zurückgesetzt. Sie können sich jetzt anmelden.",
    errInvalidToken: "Dieser Link ist ungültig oder wurde bereits verwendet.",
    errExpiredToken: "Dieser Link ist abgelaufen. Bitte fordern Sie einen neuen an.",
    resetNoToken: "Kein gültiger Reset-Link. Bitte fordern Sie einen neuen an.",
    emptyDeposits: "Sie haben noch keine Festgeld-Anlagen. Eröffnen Sie jetzt Ihre erste Anlage.",
    loading: "Wird geladen …",
    sbOverview: "Übersicht",
    sbFestgeld: "Festgeld",
    sbTransactions: "Transaktionen",
    sbDocuments: "Dokumente",
    sbForecast: "Prognose",
    sbStrategy: "Anlagestrategie",
    sbSecurity: "Sicherheit",
    availableBalance: "Verfügbares Guthaben",
    accountNumber: "Kontonummer",
    statusLabel: "Status",
    deposit: "Geld einzahlen",
    requestWithdrawal: "Auszahlung anfordern",
    statementPdf: "Kontoauszug (PDF)",
    securityBanner: "bis 100.000 € pro Einleger geschützt. Verwahrung bei regulierter Partnerbank in Luxemburg · Abgesichert gemäß EU-Richtlinie 2014/49/EU.",
    securityBannerBold: "bis 100.000 € pro Einleger geschützt.",
    securityBannerText: "Zugang zu über 50 europäischen Banken – plus führende Banken im Vereinigten Königreich · Abgesichert gemäß EU-Richtlinie 2014/49/EU",
    securityBannerLink: "Mehr zur Einlagensicherung",
    securityBannerExtra: "Zusätzlich werden Ihre Einlagen treuhänderisch auf einem Treuhandkonto verwahrt.",
    depositTitle: "Geld einzahlen",
    withdrawTitle: "Auszahlung anfordern",
    investTitle: "Festgeld anlegen",
    amountLabel: "Betrag (€)",
    termLabel: "Laufzeit",
    confirm: "Bestätigen",
    cancel: "Abbrechen",
    depositOk: "Einzahlung erfolgreich gutgeschrieben.",
    withdrawOk: "Auszahlung angefordert.",
    investOk: "Festgeld erfolgreich angelegt.",
    insufficient: "Nicht genügend verfügbares Guthaben.",
    invalidAmount: "Bitte einen gültigen Betrag eingeben.",
    noTransactions: "Noch keine Transaktionen vorhanden.",
    txDeposit: "Einzahlung",
    txWithdrawal: "Auszahlung",
    txInvest: "Festgeldanlage",
    colDate: "Datum",
    colType: "Vorgang",
    statusCompleted: "Abgeschlossen",
    statusPending: "In Bearbeitung",
    documentsTitle: "Dokumente",
    documentsDesc: "Laden Sie Ihren aktuellen Kontoauszug als PDF herunter.",
    invest: "Anlegen",
    statementHeading: "Kontoauszug",
    generatedOn: "Erstellt am",
  },
  chat: {
    title: "Barlow Assistent",
    subtitle: "Fragen zu Festgeld, Sicherheit & Gebühren",
    greeting: "Hallo! Ich beantworte gern Ihre Fragen zu unseren Festgeld-Angeboten, zur Einlagensicherung und zu den Gebühren. Wie kann ich helfen?",
    faqLabel: "Häufige Fragen",
    faqs: ["Wie sicher ist mein Geld?", "Welche Zinsen bieten Sie?", "Welche Gebühren fallen an?", "Wie eröffne ich ein Konto?"],
    placeholder: "Nachricht schreiben …",
    error: "Entschuldigung, es gab ein Problem. Bitte versuchen Sie es später erneut.",
    open: "Chat öffnen",
    close: "Schließen",
  },
};

export default de;
